require('./HelpVideo.css');

export type Props = {
    title: string;
    description: string;
    url: string;
};

export const HelpVideo = ({ title, description, url }: Props) => {
    return (
        <div className="help-video">
            <div className="_title">
                { title }
            </div>
            <div className="_desc">
                { description }
            </div>
            <iframe
                title={ title }
                src={ url }
                width="640"
                height="360"
                allow="fullscreen"
            />
        </div>
    );
};
